<template>
  <!--404-->
  <div class="main" @click="goHome" />
</template>
<script>
export default {
  name: '404',
  methods: {
    goHome() {
      this.$router.push({
        name: 'Home'
      })
    }
  }
}
</script>

<style scoped>
  .main{
    width: 100%;
    height: 100vh;
    background: url('https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1561469186&di=8b172f6a9ae63f8415b96e06d73e5161&imgtype=jpg&er=1&src=http%3A%2F%2Fimg.zcool.cn%2Fcommunity%2F01f2585931572fa8012193a3422173.png%401280w_1l_2o_100sh.png') no-repeat ;
    background-size: cover;
    cursor: pointer;
  }
</style>
mixin
